namespace SP.Search {
	export class Address {
		public static Debug = false;
		private input: HTMLInputElement;
		private id: string = SP.getParam("id");
		private autoComlete: SP.AutoComplete;
		constructor(elm: HTMLInputElement | string) {
			if(typeof elm == "string") {
				this.input = document.querySelector(elm);
			}
			else {
				this.input = elm;
			}
			const option = this.CreateAutoCompleteOptions();
			this.autoComlete = new SP.AutoComplete(this.input, option);

			Address.log("SelectAddressField is activated", this);
		}

		static log(...args: any) {
			if (!this.Debug) return;
			console.log(...args);
		}

		public static AutoSetup() {
			const searchAddressFields = document.querySelectorAll("[data-search-address-key]");
			searchAddressFields.forEach((elm: HTMLInputElement) => {
				new Address(elm);
			});
		}

		private CreateAutoCompleteOptions() {
			let options: SP.AutoCompleteSettingsInterface = <any>{};
			options.data = {
				src: this.GetAddresses.bind(this),
				key: this.input.getAttribute("data-search-address-src-key") ?? "id",
			};
			options.searchDelay = 200;
			options.render = this.ConstructAddressStringHTML.bind(this);
			options.onSelect = this.SelectedAddress.bind(this);
			options.cacheResult = true;
			return options;
		}

		async GetAddresses() {
			const response = await fetch(`/api/v1/address/list?pagesize=10&addressType=1&keyword=${this.input.value}`, {
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'pragma': 'no-cache',
					'cache-control': 'no-cache',
					'api-customer': `${this.id}`
				}
			});

			const result = await response.json();
			if (result.status = !200) alert(result.msg);

			return SP.promise(result.data);
		}
		private SelectedAddress(address: SP.Address) {
			this.input.value = this.ConstructAddressString(address);
			let key = this.input.getAttribute("data-search-address-key").toLocaleLowerCase();
			let query = `[data-search-address-${key}]`;
			let valuesOutputs = document.querySelectorAll(query);
			Address.log("Found ", valuesOutputs, "for", query);
			valuesOutputs.forEach((valueOutput: HTMLElement | HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) => {
				let k: AddressKeys = valueOutput.getAttribute("data-search-address-location-address").toLocaleLowerCase() as AddressKeys;
				if (valueOutput instanceof HTMLInputElement ||
					valueOutput instanceof HTMLSelectElement ||
					valueOutput instanceof HTMLTextAreaElement) {
					Address.log("Setting value on", valueOutput, "to", address[k]);
					valueOutput.value = this.ToValueString(address[k]);
				} else {
					Address.log("Setting innerText on", valueOutput, "to", address[k]);
					valueOutput.innerText = this.ToValueString(address[k]);
				}
			});
		}

		private ToValueString(val: any) {
			switch (typeof val) {
				case "string":
					return val;
				case "object":
					return JSON.stringify(val);
				case 'undefined':
					return "";
				default:
					return val.toString();
			}
		}

		private ConstructAddressString = function (address: SP.Address) {
			return `${address.street1}, ${address.country}-${address.zipcode} ${address.city}`;
		};

		ConstructAddressStringHTML(address: SP.Address) {
			return `<div class='address_result'><b>${address.name}</b> <br />${address.street1}, ${address.country}-${address.zipcode} ${address.city}</div>`;
		}
	}
	type AddressKeys = keyof SP.Address;
}

document.addEventListener("DOMContentLoaded", SP.Search.Address.AutoSetup);